import { apiClient, withApiPath } from './client';

// =====================
// Message Threads API
// =====================

export const getMessageThreads = async (params?: {
  status?: string;
  archived?: boolean;
  box?: 'inbox' | 'sent' | 'archived';
  all?: boolean;
}) => {
  const response = await apiClient.get(withApiPath('communications/threads'), {
    params
  });
  return response.data.threads;
};

export const getMessageThread = async (threadId: number) => {
  const response = await apiClient.get(withApiPath(`communications/threads/${threadId}`));
  return response.data;
};

export const createMessageThread = async (data: {
  learnerId: number;
  teacherId?: number;
  subject?: string;
  content: string;
}) => {
  const response = await apiClient.post(withApiPath('communications/threads'), data);
  return response.data;
};

export const sendMessageReply = async (data: {
  threadId: number;
  content: string;
}) => {
  const response = await apiClient.post(withApiPath('communications/messages'), data);
  return response.data;
};

export const markMessageAsRead = async (messageId: number) => {
  const response = await apiClient.put(withApiPath(`communications/messages/${messageId}/read`), {});
  return response.data;
};

export const getUnreadMessageCount = async () => {
  const response = await apiClient.get(withApiPath('communications/unread-count'));
  return response.data.unreadCount;
};

export const archiveThread = async (threadId: number, archive: boolean = true) => {
  const response = await apiClient.put(withApiPath(`communications/threads/${threadId}/archive`), { archive });
  return response.data;
};

export const searchMessages = async (params: {
  q?: string;
  dateFrom?: string;
  dateTo?: string;
  readStatus?: boolean;
  all?: boolean;
}) => {
  const response = await apiClient.get(withApiPath('communications/search'), {
    params
  });
  return response.data.results;
};

export const flagMessage = async (messageId: number, flagReason?: string) => {
  const response = await apiClient.put(withApiPath(`communications/messages/${messageId}/flag`), { flagReason });
  return response.data;
};

// =====================
// Learner Links API
// =====================

export const getTeachersAndLearners = async () => {
  const response = await apiClient.get(withApiPath('communications/teachers/learners'));
  return response.data;
};

// =====================
// Notices API (existing)
// =====================

export const getNotices = async () => {
  const response = await apiClient.get(withApiPath('communications/notices'));
  return response.data.notices;
};

export const createNotice = async (data: {
  title: string;
  message: string;
  audience?: string;
}) => {
  const response = await apiClient.post(withApiPath('communications/notices'), data);
  return response.data;
};

export const deleteNotice = async (noticeId: string) => {
  const response = await apiClient.delete(withApiPath(`communications/notices/${noticeId}`));
  return response.data;
};

